import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import "./Contact.css";
import { BACKEND_URL } from "../../../config";

function Contact() {

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    agree: false,
  });

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {

  e.preventDefault();

  try {

    const res = await fetch(
      `${BACKEND_URL}/api.php?module=contact`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      }
    );

    const data = await res.json();

    if (data.success) {

      alert("Message Sent ✔");

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: ""
      });

    } else {
      alert(data.message);
    }

  } catch {
    alert("Server Error");
  }
};

  return (
    <div className="contact-page">

    {/* 🔥 SEO */}
    <Helmet>
      <title>Contact Us | Realgeneric shop Pharmacy</title>

      <meta
        name="description"
        content="Contact Realgeneric shop for any queries, support or feedback. We are available 24/7 to help you with your health needs."
      />

      <meta
        name="keywords"
        content="contact Realgeneric shop, pharmacy support, online medicine help, customer care"
      />

      {/* Social sharing */}
      <meta property="og:title" content="Contact Realgeneric shop" />
      <meta property="og:description" content="Get in touch with our pharmacy support team" />
      <meta property="og:type" content="website" />
      <link rel="canonical" href="https://realgenericshop.com/contact" />
    </Helmet>

      <div className="contact-container">

        <span className="contact-tag">
          Contact Us
        </span>

        <h1>
          Get in touch
        </h1>

        <p className="contact-subtitle">
          For any queries or feedback, feel free to reach out.
        </p>

        <form onSubmit={handleSubmit}>

          <div className="form-row">

            <div className="form-group">
              <label>First name</label>
              <input
                type="text"
                name="firstName"
                placeholder="Enter first name"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Last name</label>
              <input
                type="text"
                name="lastName"
                placeholder="Enter last name"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="form-row">

            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                placeholder="you@company.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="text"
                name="phone"
                placeholder="+1 (555) 000-0000"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="form-group">
            <label>What's on your mind? *</label>

            <textarea
              rows="6"
              name="message"
              placeholder="Leave your message here"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <div className="checkbox-wrap">

            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />

            <span>
              I have read and agree to the
              <a href="/"> Privacy Policy</a>.
            </span>

          </div>

          <button
            type="submit"
            className="contact-btn"
          >
            Send message
          </button>

        </form>

      </div>

    </div>
  );
}

export default Contact;